export default "__VITE_ASSET__BVANe5MX__"